import React from 'react'

const Schools = () => {
  return (
    <div>
   <div className="schools">
  <p>
  • School Social Work - counselling, case management, and learner advocacy<br></br>
• Anti-Bullying Campaigns & Policy Support<br></br>
• Behavioural Support & Mentorship - for children and youth at risk<br></br>
• Psycho-Educational Workshops - emotional intelligence, study skills, mental health literacy<br></br>
• Crisis Intervention - after loss, violence, or disasters<br></br>
• Special Needs Support - advocacy, referrals, and inclusion programs<br></br>
  </p>

   </div>

    </div>
  )
}

export default Schools